module.exports = __webpack_public_path__ + "media/images/close-45f8608c0b2c4cb799c62700720d0427.png";